import React from 'react';
import { cx } from '../../utils/cx.js';

const RING_SIZES = { sm: 'h-4 w-4 border-2', md: 'h-8 w-8 border-[3px]', lg: 'h-10 w-10 border-4' };

/** Brand ring spinner. `label` is announced to screen readers. */
export const SpinnerRing = ({ size = 'md', label = 'Chargement…', className = '' }) => (
  <span role="status" className={cx('inline-flex', className)}>
    <span className={cx('animate-spin rounded-full border-brand-600 border-t-transparent dark:border-brand-400 dark:border-t-transparent', RING_SIZES[size] || RING_SIZES.md)} aria-hidden />
    <span className="sr-only">{label}</span>
  </span>
);

/** Block loader: ring + message, centered in the space it is given. */
export const Spinner = ({ message = 'Chargement…', size = 'md', className = '' }) => (
  <div className={cx('flex flex-col items-center justify-center gap-3 px-6 py-16 text-center', className)}>
    <SpinnerRing size={size} label={message} />
    {message && <p className="text-sm text-gray-500 dark:text-gray-400">{message}</p>}
  </div>
);

export default Spinner;
